/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_BtnInputs */

const en_service_health_nav_landing_btn = /** @type {(inputs: Service_Health_Nav_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn About Novus Health`)
};

const fr_service_health_nav_landing_btn = /** @type {(inputs: Service_Health_Nav_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur Novus Health`)
};

/**
* | output |
* | --- |
* | "Learn About Novus Health" |
*
* @param {Service_Health_Nav_Landing_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_btn = /** @type {((inputs?: Service_Health_Nav_Landing_BtnInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_BtnInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_btn(inputs)
	return fr_service_health_nav_landing_btn(inputs)
});